import React, { useMemo } from 'react';
import sendIcon from '@/widget/ui/images/send-icon.svg';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import useInitConversation from '@/widget/ui/hooks/useInitConversation';
import useOperatorsLoader from '@/widget/ui/hooks/useOperatorsLoader';
import { ReactSVG } from 'react-svg';
import styles from './ConversationStartButton.module.scss';

function ConversationStartButton() {
  const { settings } = useChatWidgetContext();
  const { operators } = useOperatorsLoader();
  const {
    textOnline, textOffline, host, color: backgroundColor, textColor: color,
  } = settings;
  const { initConversation } = useInitConversation();

  const subCaption = useMemo(() => (operators.length ? textOnline : textOffline), [operators, textOffline, textOnline]);

  return (
    <div className={styles.container} onClick={initConversation}>
      <div className={styles.captions}>
        <div className={styles.caption}>
          {window.ChatWidget.i18n.t('chat_widget.writeUs')}
        </div>
        <div className={styles.subCaption}>
          {subCaption}
        </div>
      </div>
      <div
        className={styles.sendButtonIcon}
        style={{ backgroundColor, color }}
      >
        <ReactSVG src={host + sendIcon} />
      </div>
    </div>
  );
}

export default ConversationStartButton;
